import { soapActionTypes } from './../constants/ApiConstants';

const initialState = {
  app_data: null,
  master_data: [],
  loading: false,
  get_soap: null,
  saved_soap: {},
  searched_ICDs: [],
  searched_CPTs: [],
  appointment: null,
  serviceCodesBlockedUnit: null,
  telehealthSessionDetails: null,
  saved_EncounterSigns: null,
  clockin_time: null,
  clockout_time: null,
  get_PreviousSessionNotesDetails: null,
  dataCollectionData: null,
};


export default (state = initialState, { type, payload }) => {
  switch (type) {
  case soapActionTypes.get_masterdata.REQUEST:
  case soapActionTypes.get_patient_encounters.REQUEST:
  case soapActionTypes.get_patient_single_encounters.REQUEST:
  case soapActionTypes.get_ICD_byName.REQUEST:
  case soapActionTypes.getPatientPayerServiceCodes.REQUEST:
  case soapActionTypes.create_claim.REQUEST:
  case soapActionTypes.get_appConfig.REQUEST:
  case soapActionTypes.post_patient_soap.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case soapActionTypes.get_appConfig.SUCCESS:
    return {
      ...state,
      loading: true,
      app_data: payload,
    };
  // special cases for reseting the initial states ...
  case soapActionTypes.get_patient_soap.REQUEST:
    return {
      ...state,
      loading: true,
      get_soap: null,
      get_PreviousSessionNotesDetails: null,
    };

  case soapActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };

  case soapActionTypes.get_patient_encounters.SUCCESS:
    return {
      ...state,
      encounters: payload,
      loading: false,
    };
  case soapActionTypes.get_patient_single_encounters.SUCCESS:
    return {
      ...state,
      singleEncounter: payload.data,
      loading: false,
    };
  case soapActionTypes.post_patient_soap.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_soap: payload,
    };
  case soapActionTypes.post_patient_soap.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case soapActionTypes.get_patient_soap.SUCCESS:
    return {
      ...state,
      loading: false,
      get_soap: payload,
    };
  case soapActionTypes.get_appointment_by_id.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
      appointment: null,
    };
  case soapActionTypes.get_appointment_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment: payload,
    };
  case soapActionTypes.get_ICD_byName.SUCCESS:
    return {
      ...state,
      loading: false,
      searched_ICDs: payload,
    };
  case soapActionTypes.getPatientPayerServiceCodes.SUCCESS:
    return {
      ...state,
      loading: false,
      searched_CPTs: payload,
    };
  case soapActionTypes.create_claim.SUCCESS:
  case soapActionTypes.create_claim.FAILURE:
    return {
      ...state,
      loading: false,
    };
  case soapActionTypes.updateServiceCodeBlockedUnits.REQUEST:
    return {
      ...state,
      loading: false,
    };
  case soapActionTypes.updateServiceCodeBlockedUnits.SUCCESS:
    return {
      ...state,
      loading: false,
      serviceCodesBlockedUnit: payload,
    };
  case soapActionTypes.get_telehealth_session.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case soapActionTypes.get_telehealth_session.SUCCESS:
    return {
      ...state,
      loading: false,
      telehealthSessionDetails: payload,
    };
  case soapActionTypes.post_EncounterSigns.REQUEST:
    return {
      ...state,
      loading: true,
      saved_EncounterSigns: null,
    };
  case soapActionTypes.post_EncounterSigns.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_EncounterSigns: payload,
    };
    case soapActionTypes.get_TargetsAndProgramsData.REQUEST:
      return {
        ...state,
        loading: true,
        targetsAndProgramsData: null,
      };
    case soapActionTypes.get_TargetsAndProgramsData.SUCCESS:
      return {
        ...state,
        loading: false,
        targetsAndProgramsData: payload,
      };
      case soapActionTypes.get_BehaviorsReductionsData.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorsReductionsData: null,
      };
    case soapActionTypes.get_BehaviorsReductionsData.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorsReductionsData: payload,
      };
    case soapActionTypes.post_clockin_time.REQUEST:
      return {
        ...state,
        loading: false,
      };
    case soapActionTypes.post_clockin_time.SUCCESS:
      return {
        ...state,
        loading: false,
        clockin_time: payload,
      };
    case soapActionTypes.get_PreviousSessionNotesDetails.REQUEST:
    return {
      ...state,
      loading: true,
      get_PreviousSessionNotesDetails: null,
    };
    case soapActionTypes.get_PreviousSessionNotesDetails.SUCCESS:
      return {
        ...state,
        loading: false,
        get_PreviousSessionNotesDetails: payload,
      };
      case soapActionTypes.post_clockout_time.REQUEST:
      return {
        ...state,
        loading: false,
      };
    case soapActionTypes.post_clockout_time.SUCCESS:
      return {
        ...state,
        loading: false,
        clockout_time: payload,
      };
  case soapActionTypes.get_DataCollectionData.REQUEST:
    return {
      ...state,
      loading: true,
      dataCollectionData: null,
    };
  case soapActionTypes.get_DataCollectionData.SUCCESS:
    return {
      ...state,
      loading: false,
      dataCollectionData: payload,
    };
    case soapActionTypes.post_patient_encounter_generate_narrative_summary.REQUEST:
      return {
        ...state,
        loading: true,
        narrativeAISummaryResponse: null,
        narrativeAISummaryError: null,
        isGeneratingNarrativeSummary: true
      };
  
    case soapActionTypes.post_patient_encounter_generate_narrative_summary.SUCCESS:
      return {
        ...state,
        loading: false,
        narrativeAISummaryResponse: payload,
        narrativeAISummaryError: null,
        isGeneratingNarrativeSummary: false
      };
  
    case soapActionTypes.post_patient_encounter_generate_narrative_summary.FAILURE:
      return {
        ...state,
        loading: false,
        narrativeAISummaryResponse: null,
        narrativeAISummaryError: payload.message,
        isGeneratingNarrativeSummary: false
      };

    case 'CLEAR_NARRATIVE_SUMMARY':
      return {
        ...state,
        narrativeAISummaryResponse: null,
      }
  default:
    return state;
  }

};




// WEBPACK FOOTER //
// ./src/modules/scheduling/components/soap/reducers/soapReducer.js